import {
  Modal,
  SafeAreaView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { color_3C3C3C, ColorRed, white } from "../assets/style/colors";

export const CommonModal = (props: {
  title: string;
  content: string;
  cancelText: string;
  confirmText: string;
  visible: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) => {

  const handleConfirm = () => {
    props.onClose();
    props.onConfirm();
  };

  return (
    <Modal
      statusBarTranslucent={true}
      animationType={"fade"}
      transparent={true}
      onRequestClose={props.onClose}
      visible={props.visible}
    >
      <TouchableOpacity
        style={{
          flex: 1,
          backgroundColor: "rgba(0,0,0,0.5)",
          justifyContent: "center",
          alignItems: "center",
        }}
        activeOpacity={1}
        onPress={props.onClose}
      >
        <SafeAreaView
          style={{
            width: "85%",
            maxWidth: 500,
            backgroundColor: white,
            borderRadius: 20,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.3,
            shadowRadius: 8,
            elevation: 8,
          }}
        >
          <TouchableOpacity
            activeOpacity={1}
            onPress={(e) => e.stopPropagation()}
          >
            <View style={{ padding: 28 }}>
              <Text
                style={{
                  fontSize: 20,
                  fontWeight: "600",
                  color: "#1A1A1A",
                  textAlign: "center",
                  marginBottom: 12,
                  marginTop: 8,
                  letterSpacing: 0.3,
                }}
              >
                {props.title}
              </Text>
              <Text
                style={{
                  fontSize: 15,
                  color: "#666",
                  textAlign: "center",
                  marginBottom: 28,
                  lineHeight: 22,
                  paddingHorizontal: 8,
                }}
              >
              {props.content}
              </Text>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: 12,
                }}
              >
                <TouchableOpacity
                  activeOpacity={0.8}
                  style={{
                    flex: 1,
                    backgroundColor: "#F5F5F5",
                    borderRadius: 10,
                    paddingVertical: 16,
                    alignItems: "center",
                    justifyContent: "center",
                    borderWidth: 1,
                    borderColor: "#E0E0E0",
                  }}
                  onPress={props.onClose}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      color: color_3C3C3C,
                      fontWeight: "500",
                    }}
                  >
                    {props.cancelText}
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  activeOpacity={0.8}
                  style={{
                    flex: 1,
                    backgroundColor: ColorRed,
                    borderRadius: 10,
                    paddingVertical: 16,
                    alignItems: "center",
                    justifyContent: "center",
                    shadowColor: ColorRed,
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.3,
                    shadowRadius: 4,
                    elevation: 3,
                  }}
                  onPress={handleConfirm}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      color: white,
                      fontWeight: "600",
                    }}
                  >
                    {props.confirmText}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </TouchableOpacity>
        </SafeAreaView>
      </TouchableOpacity>
    </Modal>
  );
};
